<app-preloader></app-preloader>
<app-navbar></app-navbar>
    <router-outlet></router-outlet>
    <lib-ng-toast></lib-ng-toast>
    <app-facebook></app-facebook>
<app-footer></app-footer>


